import React from "react";
import { StyleSheet, View, ScrollView, Text, Platform } from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import ReflectionList from "../../reflection/list/ReflectionList";

export default function LastWeekTemplateHours({ templateData, controller }) {
  return (
    <>
      <View style={styles.intervals}>
        <View style={styles.dayTile}>
          <Text style={styles.dayText}>Day</Text>
        </View>
        <View style={styles.dayTile}>
          <Text style={styles.dayText}>Total</Text>
        </View>
      </View>

      <ScrollView contentContainerStyle={appStyles.scrollViewContent}>
        <ReflectionList
          reflections={templateData}
          controller={controller}
          reverse={false}
          source={"last_week"}
        />
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  intervals: {
    width: "100%",
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    paddingRight: 15,
    marginTop: 20,
  },
  dayTile: {
    width: 40,
    marginBottom: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dayText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    textAlign: "center",
    color: AppTheme.almostBlack,
  },
});
